import React, { useEffect } from 'react'
import { NotFound, useHistory, useLocation } from '@fs/zion-router'
import { useTreeStartingPid, useGroupsContext, useLastViewedPid } from '@fs/zion-tree-groups'
import { type PID } from '@fs/zion-tree-types'
import PersonPageSkeleton from '../person-page/PersonPageSkeleton'
import { generatePersonPageUrl, type PersonSubPage } from '../person-page/personPageRouteUtil'

type Props = {
  subPage: PersonSubPage
}

export function RedirectToStartingPid({ subPage }: Props): JSX.Element {
  const { currentTreeId } = useGroupsContext()
  const { loading: startingPidLoading, data } = useTreeStartingPid(currentTreeId || 'PRIVATE')
  const { loading: pidLoading, pid } = useLastViewedPid()
  const history = useHistory()
  const { search } = useLocation()

  // If there's a groupId set, use the startingPerson, not the cached last viewed pid
  const targetPid = ((!currentTreeId && pid) || data?.personId) as PID | undefined
  const targetUrl =
    !startingPidLoading && !pidLoading && targetPid && subPage
      ? generatePersonPageUrl(subPage, targetPid, search)
      : null

  useEffect(() => {
    if (targetUrl) history.replace(targetUrl)
  }, [targetUrl, history])

  if (startingPidLoading || pidLoading) return <PersonPageSkeleton />
  if (!targetPid || !subPage) return <NotFound />
  return <PersonPageSkeleton />
}
